const escapeDoubleQuotes = (string: string) => {
  let Finalstring = string.replace(/\"/g, '\\"');
  return Finalstring;
};


export default escapeDoubleQuotes;
